import { render, staticRenderFns } from "./FieldsetAccountGeneral.yaml?vue&type=template&id=795f223e&component"
import script from "./FieldsetAccountGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetAccountGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports